import { render, staticRenderFns } from "./ClaimingDisabledModal.vue?vue&type=template&id=17c49c47&scoped=true&"
import script from "./ClaimingDisabledModal.vue?vue&type=script&lang=js&"
export * from "./ClaimingDisabledModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimingDisabledModal.vue?vue&type=style&index=0&id=17c49c47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c49c47",
  null
  
)

export default component.exports